import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import { parseApiError, overrideOrganizationHeader } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import type { RequiredProps } from '@cast/shared-types';
import { UsersOrganization } from '@cast/types';

import { ENTERPRISE_ORGANIZATION_CHILDREN_QUERY_KEY } from 'hooks/queries/enterprise';

import { ORGANIZATIONS_QUERY_KEY } from '@cast/infrastructure-organization';

type UseUpdateOrganizationMutation = UseMutationResult<
  unknown,
  unknown,
  RequiredProps<Partial<UsersOrganization>, 'id' | 'name'>
>;

export const useUpdateOrganizationMutation = (
  onSuccess?: () => void
): UseUpdateOrganizationMutation => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) =>
      apiClient.user.updateOrganization(
        {
          id: payload.id,
          organization: payload,
        },
        {
          headers: overrideOrganizationHeader(payload.id),
        }
      ),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [ORGANIZATIONS_QUERY_KEY],
      });
      await queryClient.invalidateQueries({
        queryKey: [ENTERPRISE_ORGANIZATION_CHILDREN_QUERY_KEY],
      });
      notify.success('Organization updated successfully');
      onSuccess?.();
    },
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
